export enum AssinaturaSituacaoEnum {
  PENDENTE = 'PENDENTE',
  ASSINADO = 'ASSINADO',
  ASSINANDO = 'ASSINANDO',
  REJEITADO = 'REJEITADO',
  RECUSADO = 'RECUSADO'
}
